module.exports = __webpack_public_path__ + "img/tenant-hero-mobile.27cdf20d.svg";